// This function allow to reference chunks
__webpack_require__.miniCssF = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "css/async/" + (chunkId === "1036" ? "component-carousel" : chunkId) + "." + {"1036": "3638b148","8868": "e63d3134","8976": "9c234b40","9463": "6f382390",}[chunkId] + ".css"
}